<div class="container" [ngClass]="{'blue':open}">
    <div class="group">
        <div class="open" (click)="openGroup($event)">
            <img src="/assets/images/types/dropdown.svg" class="dropdown-img" *ngIf="this.open" />
            <img src="/assets/images/types/dropdown-close.svg" class="dropdown-img scale-img" *ngIf="!this.open" />
        </div>
        <!-- group?.color -->
        <div class="group-logo">
            <que-distribution-group-square [color]="group?.color" [name]="group?.name"
                [size]="'35px'"></que-distribution-group-square>
        </div>
        <p class="name">{{group?.name}}</p>
    </div>
    <div *ngIf="open" class="recipients-list">
        <div *ngFor="let recipient of group?.users">
            <que-mini-contact-display [user]="recipient.user" [isTooltip]="true"></que-mini-contact-display>
        </div>
    </div>
</div>